module.exports = {
	"config": {
		"siteTitle": "Blog by ShinyLee",
		"siteDescr": "搞前端的，玩爱玩的。",
		"siteAuthor": "ShinyLee",
		"siteTwitterUrl": "https://twitter.com/shinylee007",
		"siteGithubUrl": "https://github.com/ShinyLeee",
		"siteEmailUrl": "lshinylee007@gmail.com",
		"googleAnalyticsId": "UA-93455154-1",
		"linkPrefix": "/blog"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"title": 404,
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-03-11 Gatsby",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-03-11 Gatsby",
				"stem": "index",
				"path": "articles/2017-03-11 Gatsby/index.md"
			},
			"requirePath": "articles/2017-03-11 Gatsby/index.md",
			"path": "/articles/2017-03-11/",
			"data": {
				"title": "部署Github Page",
				"date": "2017-03-11T14:07:32.306Z",
				"layout": "post",
				"path": "/articles/2017-03-11/",
				"category": "前端",
				"description": "使用基于React的Gatsby构建静态页面博客并部署到Github Page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-03-14 Webpack",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-03-14 Webpack",
				"stem": "index",
				"path": "articles/2017-03-14 Webpack/index.md"
			},
			"requirePath": "articles/2017-03-14 Webpack/index.md",
			"path": "/articles/2017-03-14/",
			"data": {
				"title": "搭建React组件开发环境",
				"date": "2017-03-14T11:16:59.638Z",
				"layout": "post",
				"path": "/articles/2017-03-14/",
				"category": "前端",
				"description": "从零开始搭建基于Babel及Webpack2可热加载的React组件开发环境"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-03-17 React-Loadable",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-03-17 React-Loadable",
				"stem": "index",
				"path": "articles/2017-03-17 React-Loadable/index.md"
			},
			"requirePath": "articles/2017-03-17 React-Loadable/index.md",
			"path": "/articles/2017-03-18/",
			"data": {
				"title": "[译]介绍React Loadable",
				"date": "2017-03-18T06:39:25.028Z",
				"layout": "post",
				"path": "/articles/2017-03-18/",
				"category": "前端",
				"description": "以组件为中心的Code Splitting及在React中进行动态加载"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-02 Interview",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-02 Interview",
				"stem": "index",
				"path": "articles/2017-04-02 Interview/index.md"
			},
			"requirePath": "articles/2017-04-02 Interview/index.md",
			"path": "/articles/2017-04-02/",
			"data": {
				"title": "忙碌的春招之旅",
				"date": "2017-04-02T09:33:37.715Z",
				"editDate": "2017-04-04T14:05:08.608Z",
				"layout": "post",
				"path": "/articles/2017-04-02/",
				"category": "前端",
				"description": "春招笔试资料"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md"
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "关于我",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md"
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "联系我",
				"layout": "page",
				"path": "/contact"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0